const gql = {
  query: `query getAddressList {
    getAddressList {
      success
      data {
        allowAddressChange
        taAccounts {
          comWebAccounts {
            addressInfo {
              formData
              mailingAddress
              residentialAddress
              text
              allowAddressChange
            }
          }
        }
        tracAccounts {
          comWebAccounts {
            addressInfo {
              formData
              mailingAddress
              residentialAddress
              text
            }
          }
        }
      }
    }
  }`,
  meta: {
    label: "Get Address List",
  },
};

export default gql;
